<form [formGroup]="form" autocomplete="off">
    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">

            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>

            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" type="button" (click)="saveCopia()" class="btn btn-outline-success" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>

            <div *ngIf="habilitarEmitir">
                <button *ngIf="!visibilitySpinnerEmitir" type="button" (click)="emitirCopia()" class="btn btn-outline-success" title="Emitir"><i class="fa fa-leaf"></i> Emitir</button>
                <button *ngIf="visibilitySpinnerEmitir" [disabled]="true" class="btn btn-outline-success">
                    <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                    Emitiendo
                </button>
            </div>

            <div *ngIf="habilitarAnular">
                <button *ngIf="!visibilitySpinnerAnular" type="button" (click)="anularCopia()" class="btn btn-outline-success" title="Anular"><i class="fa fa-ban"></i> Anular</button>
                <button *ngIf="visibilitySpinnerAnular" [disabled]="true" class="btn btn-outline-success">
                    <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                    Anulando
                </button>
            </div>

            <div *ngIf="habilitarImprimir">
                <button *ngIf="!visibilitySpinnerImprimir" type="button" (click)="printCopia()" class="btn btn-outline-success" title="Descargar"><i class="fa fa-file-pdf-o"></i> Descargar</button>
                <button *ngIf="visibilitySpinnerImprimir" [disabled]="true" class="btn btn-outline-success">
                    <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                    Descargando
                </button>
            </div>

        </div>
    </nav>


    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">{{editTitle}} Copia Certificado {{codigoSolicitud}}</h4>
        <!--<h5 style="display:inline"> ({{tituloTipoSolicitudEx}} - {{tituloEstadoSolicitudEx}})</h5>-->
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitudEx}}" />
                <label class="codigo-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitudEx}}">{{codigoTipoSolicitud}}</label>
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitudEx | IconoEstadoSolicitudEx}}" ngbTooltip="{{tituloEstadoSolicitudEx}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" ngbTooltip="{{tituloEstadoCertificadoFitoEx}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoCopia | IconoCopiaCertificadoEx}}" ngbTooltip="{{tituloEstadoCopia}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <div class="row">
                    <!--DATOS BASICOS -->
                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">

                            <a class="card-header-a" (click)="isCollapsedDatosBasicos = !isCollapsedDatosBasicos" [attr.aria-expanded]="!isCollapsedDatosBasicos" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos básicos
                                    <i *ngIf="isCollapsedDatosBasicos" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedDatosBasicos" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>

                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedDatosBasicos" [ngbCollapse]="isCollapsedDatosBasicos">
                                    <div class="row">

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="intEstado">Tipo</label>
                                            <ng-select [items]="listTipo"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdTipoSolicitudCopiaEx"
                                                       loadingText="Cargando..."
                                                       [loading]="!listTipo"
                                                       notFoundText="Tipo no encontrado"
                                                       placeholder="-- Seleccione un Tipo --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdTipoSolicitudCopiaEx')">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdTipoSolicitudCopiaEx','required')">
                                                Tipo es obligatorio
                                            </div>
                                        </div>



                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpNumCertificadoOriginal">Certificado Original</label>
                                            <input formControlName="NumCertificadoOriginal" readonly name="NumCertificadoOriginal" [ngClass]="displayFieldCss('NumCertificadoOriginal')" title=""
                                                   class="form-control" id="inpNumCertificadoOriginal" type="text" value="" maxlength="50">


                                        </div>



                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpNumCopias">Nº Copia</label>
                                            <input formControlName="NumCopia" numbersOnly readonly name="NumCopia" [ngClass]="displayFieldCss('NumCopia')" title=""
                                                   class="form-control" id="inpNumCopias" type="text" value="" maxlength="50">


                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpCodigo">Código</label>
                                            <input formControlName="Codigo" readonly name="Codigo" [ngClass]="displayFieldCss('Codigo')" title=""
                                                   class="form-control" id="inpCodigo" type="text" value="" maxlength="50">


                                        </div>


                                    </div>

                                    <div class="row">

                                        <div class="form-group col-md-12">
                                            <label class="col-form-label" for="inpCodigo">Observaciones</label>
                                            <textarea style="resize:none" formControlName="Observaciones" [ngClass]="displayFieldCss('Observaciones')"
                                                      maxlength="5000" name="Observaciones" title="" type="text" class="form-control" inputStyleClass="form-control"
                                                      value=""></textarea>

                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <!--OTROS DATOS -->
                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">

                            <a class="card-header-a" (click)="isCollapsedOtrosDatos = !isCollapsedOtrosDatos" [attr.aria-expanded]="!isCollapsedOtrosDatos" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Otros datos
                                    <i *ngIf="isCollapsedDatosBasicos" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedDatosBasicos" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>

                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedOtrosDatos" [ngbCollapse]="isCollapsedOtrosDatos">
                                    <div class="row">

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpEstado">Estado</label>
                                            <input formControlName="Estado" readonly name="NumCopia" [ngClass]="displayFieldCss('Estado')" title=""
                                                   class="form-control" id="inpEstado" type="text" value="" maxlength="50">


                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpNumCopias">Fecha Petición</label>
                                            <input formControlName="FechaPeticion" readonly name="FechaPeticion" [ngClass]="displayFieldCss('FechaPeticion')" title=""
                                                   class="form-control" id="inpFechaPeticion" type="text" value="" maxlength="50">


                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpFechaInspeccion">Fecha Inspección</label>
                                            <input formControlName="FechaInspeccion" readonly name="NumCopia" [ngClass]="displayFieldCss('FechaInspeccion')" title=""
                                                   class="form-control" id="inpFechaInspeccion" type="text" value="" maxlength="50">


                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpNumCopias">Fecha Expedición</label>
                                            <input formControlName="FechaExpedicion" readonly name="FechaExpedicion" [ngClass]="displayFieldCss('FechaExpedicion')" title=""
                                                   class="form-control" id="inpFechaExpedicion" type="text" value="" maxlength="50">


                                        </div>


                                    </div>

                                    <div class="row">

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label" for="inpFechaAnulacion">Fecha Anulación</label>
                                            <input formControlName="FechaAnulacion" readonly name="FechaAnulacion" [ngClass]="displayFieldCss('FechaAnulacion')" title=""
                                                   class="form-control" id="inpFechaAnulacion" type="text" value="" maxlength="50">


                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div *ngIf="visibilityDecision" class="row">
                    <!--DECISIÓN-->
                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedDecision = !isCollapsedDecision" [attr.aria-expanded]="!isCollapsedDecision" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Decisión
                                    <i *ngIf="isCollapsedDecision" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedDecision" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="isCollapsedDecision" [ngbCollapse]="isCollapsedDecision">
                                    <div class="group-campos">
                                        <div class="row" style="flex-wrap: nowrap">

                                            <div class="col-md-4" style="text-align:center">
                                                <p-radioButton class="radiobuttonSuccess" [ngClass]="displayFieldCss('IdDecision')" formControlName="IdDecision"
                                                               inputStyleClass="form-control" name="IdDecision" value="A" label="&nbsp;Aceptar&nbsp;"></p-radioButton>
                                            </div>
                                            <div class="col-md-4" style="text-align:center">
                                                <p-radioButton class="radiobuttonDanger" [ngClass]="displayFieldCss('IdDecision')" formControlName="IdDecision" inputStyleClass="form-control" name="IdDecision"
                                                               value="R" label="&nbsp;Rechazar&nbsp;"></p-radioButton>
                                            </div>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdDecision','required')">
                                                Decisión es obligatorio
                                            </div>


                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>



            </div>

        </div>



    </div>

</form>


